// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
		// enableSearch: true,
		// enableSuggestion: true,
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

// Start #200538 
  InstantSearchResultItemProduct.prototype.beforeRender = function () {
    if (this.url) {
      this.url = buildCustomProductItemUrlWithVariant(this.data);
    }
  }

  function buildCustomProductItemUrlWithVariant(data) {
    var variantIdPart = data.split_product && data.variants ? ("?variant=" + data.variants[0].id) : "";
	var productUrl = Utils.buildProductItemUrl(data, false);
	return productUrl + variantIdPart;
  }

// End #200538 
})();